export const diItems = {
  paging: { total: 2, count: 1000, totalPages: 1, currentPage: 0 },
  items: [
    {
      id: 'item1.1',
      idType: 'EXTERNAL_ID',
      displayInfoTitles: ['DI Item Title 1.1', 'DI Item Title 1.2'],
      itemType: 'itemType',
      itemsByDisplayInfoTitle: [
        {
          itemId: 'item1.1',
          title: 'DI1.1 Item Title',
          externalId: 'item1ext',
          clientId: 'string',
          merchantId: 'string',
          itemType: 'MAIN',
          price: 10000,
          startDate: 'string',
          endDate: 'string',
          outOfStock: false,
          outOfStockToday: false,
          createdDate: 'string',
          updatedDate: 'string',
        },
        {
          itemId: 'item1.2',
          title: 'DI1.2 Item Title',
          externalId: 'item1ext',
          clientId: 'string',
          merchantId: 'string',
          itemType: 'MAIN',
          price: 10000,
          startDate: 'string',
          endDate: 'string',
          outOfStock: false,
          outOfStockToday: false,
          createdDate: 'string',
          updatedDate: 'string',
        },
      ],
    },
    {
      id: 'item2.1',
      idType: 'ID',
      displayInfoTitles: ['DI Item Title 2.1', 'DI Item Title 2.2'],
      itemType: 'itemType',
      itemsByDisplayInfoTitle: [
        {
          itemId: 'item2.1',
          title: 'DI Item Title 2.1',
          externalId: 'item1ext',
          clientId: 'string',
          merchantId: 'string',
          itemType: 'MAIN',
          price: 10000,
          startDate: 'string',
          endDate: 'string',
          outOfStock: false,
          outOfStockToday: false,
          createdDate: 'string',
          updatedDate: 'string',
        },
        {
          itemId: 'item2.2',
          title: 'DI Item Title 2.2',
          externalId: 'item1ext',
          clientId: 'string',
          merchantId: 'string',
          itemType: 'MAIN',
          price: 10000,
          startDate: 'string',
          endDate: 'string',
          outOfStock: false,
          outOfStockToday: false,
          createdDate: 'string',
          updatedDate: 'string',
        },
      ],
    },
    {
      id: 'item3.1',
      idType: 'EXTERNAL_ID',
      displayInfoTitles: ['DI Item Title 3.1', 'DI Item Title 3.2'],
      itemType: 'itemType2',
      itemsByDisplayInfoTitle: [
        {
          itemId: 'item3.1',
          title: 'DI Item Title 3.1',
          externalId: 'item1ext',
          clientId: 'string',
          merchantId: 'string',
          itemType: 'MAIN',
          price: 10000,
          startDate: 'string',
          endDate: 'string',
          outOfStock: false,
          outOfStockToday: false,
          createdDate: 'string',
          updatedDate: 'string',
        },
        {
          itemId: 'item3.2',
          title: 'DI Item Title 3.2',
          externalId: 'item1ext',
          clientId: 'string',
          merchantId: 'string',
          itemType: 'MAIN',
          price: 10000,
          startDate: 'string',
          endDate: 'string',
          outOfStock: false,
          outOfStockToday: false,
          createdDate: 'string',
          updatedDate: 'string',
        },
      ],
    },
    {
      id: 'item.id',
      idType: 'ID',
      displayInfoTitles: ['DI Item Title ID.1', 'DI Item Title ID.2'],
      itemType: 'itemType',
      itemsByDisplayInfoTitle: [
        {
          itemId: 'item3.1',
          title: 'DI Item Title ID.1',
          externalId: 'item1ext',
          clientId: 'string',
          merchantId: 'string',
          itemType: 'MAIN',
          price: 10000,
          startDate: 'string',
          endDate: 'string',
          outOfStock: false,
          outOfStockToday: false,
          createdDate: 'string',
          updatedDate: 'string',
        },
        {
          itemId: 'item3.2',
          title: 'DI Item Title ID.2',
          externalId: 'item1ext',
          clientId: 'string',
          merchantId: 'string',
          itemType: 'MAIN',
          price: 10000,
          startDate: 'string',
          endDate: 'string',
          outOfStock: false,
          outOfStockToday: false,
          createdDate: 'string',
          updatedDate: 'string',
        },
      ],
    },
  ],
};
